import { gql } from "@apollo/client";

export const GET_POST_CODE_QUERY = gql`
    query postCode($postId: Int) {
        postCode(postId: $postId) {
                id,
                code,
        }
    }
`